import referral from './referral'
import editor from './editor'
import list from './list'

export default {
  referral,
  editor,
  list
}
